import './UserList.css';
import React, {useState, useEffect} from 'react';
import * as PropTypes from "prop-types";
import {Table} from "react-bootstrap";
import QbmModal from "../../modals/common/QbmModal";
import ReactSelect from 'react-select'
import moment from 'moment';
import Loader from "../../common/Loader";
import {FaSort, FaSortUp, FaSortDown, FaRegEye} from "react-icons/fa";
import _ from 'lodash'
import UserDetails from "./UserDetails";
import classnames from 'classnames'
import { Button, Form, Input, Pagination } from 'antd';
import TableTr from './TableTr';
import InputField from '../../helpers/Fields/InputField';

const statusList = [
    {name: 'not active', id: 0, key: 'STATUS_DELETED'},
    {name: 'active', id: 10, key: 'STATUS_ACTIVE'},
]
const accountList = [
    {name: 'admin', id: 10, key: 'ADMIN'},
    {name: 'student', id: 13, key: 'STUDENT'},
    {name: 'premium', id: 5, key: 'PREMIUM '},
    {name: 'company', id: -1, key: 'COMPANY '},
    {name: 'organisation', id: 1, key: 'ORGANISATION '},
]

const returnSortIcon = (sort, name) => {
    if (name !== sort.name || !sort.direction) {
        return <FaSort />
    }
    return sort.direction === 'desc' ? <FaSortUp/> : <FaSortDown/>
};

const UsersList = ({isLoading, users, total, getUsers, updateUser, isOpen, onOpenUserModal, onChangeStatus, onChangeAccount}) => {
    
    const [pagination, setPagination] = useState({
        limit: 10, 
        skip: 0, 
        total, 
        current: 1
    });

    const [search, setSearch] = useState({username: '', email: ''})

    useEffect(() =>{
        getUsers({limit: pagination.limit, skip: 0});
    }, []);
    const [user, setUser] = useState({});
    const [searchAccount, setSearchAccount] = useState('');
    const handleRowClick = user => {
        setUser(user);
        onOpenUserModal(true)
    }
    const [sort, toggleSort] = useState({field: {name: null, direction: null}, list: []});
    useEffect(() => {
        toggleSort({...sort, list: users});
        setPagination({...pagination, total})
    }, [users]);
    const handleClose = () => {
        onOpenUserModal(false)
    }
    const handleChangeStatus = (userId, {id}) => {
        onChangeStatus(userId, id)
    }
    const handleChangeAccount = (userId, {id}) => {
        onChangeAccount(userId, id)
    }
    const getLastLoginClass = (user) => {
        if(!user.last_login) return;
        let now = 	Math.floor(new Date().getTime()/1000.0);
        if(now - user.last_login.login_time > 604800){
            return 'text-danger';
        }else if(now - user.last_login.login_time > 259200){
            return 'text-warning';
        }else if(now - user.last_login.login_time < 86400){
            return 'text-success'
        }
    }
    const handleSort = (currentField) => {
        let direction = 'desc';
        if (currentField === sort.field.name) {
            switch (sort.field.direction) {
                case 'asc': {
                    direction = null;
                    break;
                }
                case 'desc': {
                    direction = 'asc';
                    break;
                }
                default: {
                    direction = 'desc';
                }
            }
        }
        // const sortedList = direction ? _.orderBy(users, [currentField], [direction]) : users;

        getUsers({limit: pagination.limit, skip: pagination.skip, sortName: currentField, direction, ...search});

        toggleSort({field: {name: currentField, direction}, list: users})
    }

    const searchUsers = (e) => {
        if(e){
            e.preventDefault();
        }
        getUsers({limit: pagination.limit, skip: 0, ...search});
    }
    
    return isLoading ?
        <Loader />
        :
            <div>
                <QbmModal
                    show={isOpen}
                    title={`${user.firstname} ${user.lastname} (${user.username})`}
                    onClose={handleClose}
                >
                    <UserDetails user={user}/>
                </QbmModal>

                <div className={'mb-3'}>
                    
                </div>
                <div className={'mb-3'}>
                    <div className="FilterBlock">
                        <div className="filter-select">
                            <label>Filter account</label>
                            <ReactSelect
                                valueKey={'id'}
                                labelKey={'name'}
                                options={accountList}
                                clearable={false}
                                value={searchAccount}
                                onChange={(value) => {
                                    setSearchAccount(value.id);
                                    getUsers({account: value.id, limit: pagination.limit})
                                    setPagination({...pagination, current: 1})
                                }}
                            />
                        </div>
                       <div className="FormSearch">
                           <form onSubmit={searchUsers}>
                               <InputField name="username" label="Username" input={{
                                   name: 'username',
                                   value: search.username,
                                   onChange: (e) => {setSearch({...search, username: e.target.value})}
                               }} meta={{}} />
                               <InputField name="email" label="Email" input={{
                                   name: 'email',
                                   value: search.email,
                                   onChange: (e) => {setSearch({...search, email: e.target.value})}
                               }} meta={{}}/>
                               <InputField name="organisation_name" label="Organisation name" input={{
                                   name: 'organisation_name',
                                   value: search.organisation_name,
                                   onChange: (e) => {setSearch({...search, organisation_name: e.target.value})}
                               }} meta={{}}/>
                               <button className="btn btn-info">Search</button>
                               <button type="button" onClick={() => {
                                   setSearch({username: '', email: ''});
                                   getUsers({limit: pagination.limit, skip: 0, username: '', email: ''});
                               }} className="btn btn-danger">Reset</button>
                           </form>
                       </div>
                    </div>
                    
                </div>
                <div style={{overflow: 'hidden', overflowX: 'auto', marginBottom: 20}}>
                    <Table striped bordered hover>
                        <thead>
                        <tr>
                            <th>#ID</th>
                            <th className={'sortable'} onClick={() => handleSort('username')}>User Name {returnSortIcon(sort.field, 'username')}</th>
                            <th className={'sortable'} onClick={() => handleSort('email')}>Email {returnSortIcon(sort.field, 'email')}</th>
                            <th className={'status-th'}>Total Questions</th>
                            <th className={'status-th'}>Last Login</th>
                            <th className={'status-th'}>Status Paid</th>
                            <th className={'status-th'}>Paid until</th>
                            <th className={'status-th'}>Account Type</th>
                            <th className={'status-th'}>Status</th>
                            <th className={'status-th'}>Type</th>
                            <th className={'status-th'}>Email verify</th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            sort.list.map((user, index) => (
                                <TableTr
                                    key={user.id}
                                    pagination={pagination}
                                    index={index}
                                    user={user}
                                    handleChangeAccount={handleChangeAccount}
                                    accountList={accountList} 
                                    statusList={statusList}
                                    handleChangeStatus={handleChangeStatus}
                                    handleRowClick={handleRowClick}
                                    getLastLoginClass={getLastLoginClass}
                                    toggleSort={toggleSort}
                                    sort={sort}
                                    updateUser={updateUser}
                                />
                            ))
                        }
                        </tbody>
                    </Table>
                </div>
                <Pagination total={pagination.total} defaultCurrent={1} current={pagination.current} pageSize={pagination.limit} onChange={(page, size) => {
                    setPagination({...pagination, current: page})
                    if(searchAccount){
                        getUsers({account: searchAccount, limit: pagination.limit, skip: (page -1 ) * size, ...search})
                    } else {
                        getUsers({limit: pagination.limit, skip: (page -1 ) * size, ...search})
                    }
                }} />
                <br />
            </div>
}

UsersList.propTypes = {
    isLoading: PropTypes.bool,
    isOpen: PropTypes.bool,
    users: PropTypes.array,
    getUsers: PropTypes.func,
    onOpenUserModal: PropTypes.func,
    onChangeStatus: PropTypes.func,
    onChangeAccount: PropTypes.func,
}

export default UsersList;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Users/UsersList.js